// extracted by mini-css-extract-plugin
module.exports = {"title":"ManageSettingModal_title_mlKvB","pureLabelButton":"ManageSettingModal_pureLabelButton_3kvf1","modalBody":"ManageSettingModal_modalBody_3AtDW"};